import { Inject, Injectable } from '@angular/core';
import { AJSRootScope, downgradeToAJSService } from 'ib-web-commons/utils';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable()
export class IbGastronomicProposalUtilsService {

    private updateDatalayerOptionSubj$: Subject<string> = new Subject();
    private nextFlightOptionSubj$: Subject<void> = new Subject();
    private menusSelectedSubject$: Subject<number> = new Subject();

    menusSelected$ = this.menusSelectedSubject$.asObservable();
    closeAll$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    nextFlightOptions$ = this.nextFlightOptionSubj$.asObservable();
    updateDatalayerOption$ = this.updateDatalayerOptionSubj$.asObservable();

    constructor(@Inject(AJSRootScope) private $rootScope: any) { }

    updateMenusSelected(specialMealsSelected: number) {
        this.menusSelectedSubject$.next(specialMealsSelected);
    }

    closeAll() {
        this.closeAll$.next(true);
    }

    openSpecialMeals(){
        this.$rootScope.$broadcast('openSpecialMealModalFromGastronomic');
    }

    updateDatalayerOption(type: string) {
        this.updateDatalayerOptionSubj$.next(type);
    }

    goToNextFligthOptions() {
        this.nextFlightOptionSubj$.next();
    }
}
downgradeToAJSService('IbGastronomicProposalUtilsService', IbGastronomicProposalUtilsService, 'ib-MmB-gastronomic-proposal-module');
